export const HeightStyle = { property:'HeightStyle', styleProperty: 'height'}